<template>
  <div v-show="files.length > 0">
    <div class="filesTitle" v-on:click="handleFilesDisplay">
      <span class="main-title">{{ $t('interactivity.attachment') }}</span>
            <div class="chap-arrow-icon"  v-html="!isFilesShow? SVG.DOWN_ARROW_SVG : SVG.UP_ARROW_SVG "> </div>

    </div>
    <div class="FilesSection" :class="{
      'files-shown': isFilesShow,
      'files-hidden': !isFilesShow,
    }">
      <template v-for="(file, index) in files" :key="index">
        <div class="file-row">
          <div class="file_info">
            <div class="file__index">-</div>
            <div class="file__title">{{ file.originName }}</div>
          </div>
          <div 
          v-if="this.getSkinInfos.action_download_files"
          class="file__time" @click="downloadFile(file)" v-html="SVG.DOWNLOAD_FILE_SVG">
          </div>
        </div>
      </template>
    </div>
    <div>
      <button class="download-all-btn" :class="{
        'files-shown': isFilesShow,
        'files-hidden': !isFilesShow,
      }" @click="downloadAllFiles()">
        {{ $t('interactivity.downloadAll') }}
      </button>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import en from '../../../../../i18n/en_US';
import fr from '../../../../../i18n/fr_FR';
import { SVG } from "../../../../../components/utils/const";

export default defineComponent({
  name: "FilesSection",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    files: {
      type: Array,
      required: true,
    },
    information: {
      type: Object,
      required: true,
    },
    player: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isFilesShow: true,
      SVG:SVG

    };
  },
  computed: {
    ...mapGetters(['setVideoInfos' ,"getSkinInfos"]),
  },
  methods: {
    handleFilesDisplay() {
      this.isFilesShow = !this.isFilesShow;
    },
    async downloadFile(file) {
      await axios
        .get(
          `https:${window.process.env?.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process.env?.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/download/videofile/${file?.id}`,
          {
            headers: {
              authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
              "client-name": this.setVideoInfos?.client
            },
            responseType: "blob",
          }
        )
        .then((resp) => {
          const blob = new Blob([resp.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = file.file_name;
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((e) => {
          console.error("ERROR download file", file.file_name, e);
        });
    },
    downloadAllFiles() {
      this.files?.forEach((f) => {
        this.downloadFile(f);
      });
    },
  },
});
</script>

<style>
.main-title {
  font-weight: 600;
}

.filesTitle {
  display: flex;
  align-items: center;
}

.chap-arrow-icon {
  width: auto;
  margin-left: 0.33em;
  cursor: pointer;
}
.chap-arrow-icon svg{
  width: 1.5em;
  height: 1.5em;
}
.FilesSection {
  margin: 0;
}

.FilesSection.files-hidden {
  display: none;
}

.file-row {
  display: flex;
  width: 100%;
  padding: 0.5em;
  justify-content: space-between;
  align-items: center;
}

.file-row:not(:last-child) {
  border-bottom: 1px solid var(--vm-color-three-04);
}

.file-row .file_info {
  display: flex;
}

.file__index {
  color: var(--vm-color-two) !important;
  font-weight: 600;
  margin-right: 0.2em;
}

.file__time {
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.1em;
  cursor: pointer;
  height: 1.5em;
  width: 1.5em;
}

.files-hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  margin: 0 !important;
}

.files-shown {
  opacity: 1;
  height: auto;
  transition: visibility 0s, opacity 0.5s linear;
}

.download-all-btn {
  padding: 0.25em 0.5em;
  color: var(--vm-color-one) !important;
  background-color: var(--vm-color-one-02) !important;
  cursor: pointer;
  text-align: center;
  display: flex !important;
  align-items: center;
  justify-content: left;
  width: auto;
  margin: auto;
  border-radius: 0.25em;
}
</style>
